
import CardServices from "../cardServices";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import RegisterAccess from '../../../utils/registerAccess';
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
// import { useSelector } from 'react-redux';

interface MenuState {
  analise: number;
  chefeArea: number;
  chefeDepartamentoDesalfandegamento: number;
  directoraGeralAdjuntaDesalfandegamento: number;
  directorGeralDesalfandegamento: number;

  // analisado: number;
  // deferido: number;
  reclamacoes: number;
  // solicitacoesDesalfandegamento: number;
  declaracoesEmitidas: number;
  reprovado: number;
}
type MenuProps = {
  children?: React.ReactNode
}

export default function MenuDlifDesalfandegamento({ children }: MenuProps) {
  // const user = useSelector(state => state.account.user);
  const [menu, setMenu] = useState<MenuState>({
    analise: 0,
    chefeArea: 0,
    chefeDepartamentoDesalfandegamento: 0,
    directoraGeralAdjuntaDesalfandegamento: 0,
    directorGeralDesalfandegamento: 0,

    // analisado: 0,
    // deferido: 0,
    reclamacoes: 0,
    // solicitacoesDesalfandegamento: 0,
    declaracoesEmitidas: 0,
    reprovado: 0,
  })
  const [loadMenu, setLoadMenu] = useState<boolean>(true)

  useEffect(() => {
    api.get(`/menu/dlif`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  return (
    <div className="tw-w-full">
      <RegisterAccess page={'menu desalfandegamento'} />

      <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-7 tw-px-5 tw-py-4">
        <CardServices funcao='Técnico' load={loadMenu} count={menu.analise} icone={'/icones/Desalfandegar.svg'} nomeService={'Solicitaçōes de Desalfandegamento '} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Análise'} />
        <CardServices funcao='Técnico' load={loadMenu} count={menu.reprovado} icone={'/icones/solictacoesReprovadas.svg'} nomeService={'Solicitaçōes de Reprovadas '} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Reprovado'} />
      </div>

      <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-7 tw-px-5 tw-py-4">
        <CardServices load={loadMenu} count={menu.chefeArea} icone={'/icones/chefedaSeccao.svg'} nomeService={'Chefe de Área'} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Chefe de Área'} />
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.chefeDepartamentoDesalfandegamento} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe de Departamento'} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Chefe de Departamento'} />
        <CardServices load={loadMenu} count={menu.directoraGeralAdjuntaDesalfandegamento} icone={'/icones/chefedaSeccao.svg'} nomeService={'Directora Geral Adjunta Servicos Executivos'} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Directora Geral Adjunta para os Serviços Executivos'} />
        <CardServices funcao='' load={loadMenu} count={menu.directorGeralDesalfandegamento} icone={'/icones/diretoraGeral.svg'} nomeService={'Diretor(a) Geral'} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Director Geral'} />
        <CardServices funcao='' load={loadMenu} count={menu.declaracoesEmitidas} icone={'/icones/controleQualidade/certificadosAutorizacoes.svg'} nomeService={'Declarações Emitidas'} link={'/admin/dmts/solicitacoes-de-desalfandegamento/produtos/Aprovado'} />
      </div>

      <div className="tw-flex tw-items-center tw-gap-2 tw-px-5 tw-pt-3 tw-pb-1 tw-border-t tw-border-gray-100">
        <div className="tw-w-0.5 tw-h-4 tw-bg-[#85287e]/40 tw-rounded-full" />
        <span className="tw-text-[11px] tw-font-semibold tw-tracking-widest tw-text-gray-400 tw-uppercase">Outros Serviços</span>
      </div>
      <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-7 tw-px-5 tw-py-4">
        {children}

      </div>
    </div>
  )
}

